// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610201405/js/" + chunkId + "." + {"44":"421ea695","225":"47ffeb18","481":"7bd63c9b","486":"8cdfe3d5","770":"23330f9b"}[chunkId] + ".0.5624356079048132.chunk.js";
};